const buildingData = [
  {
    img: "https://source.unsplash.com/featured/?house&sig=1",
    price: 100000,
    address: "123 Main Street, City A, Lorem ipsum dolor sit amet.",
    bed: 3,
    tub: 2,
    area: 1500,
    state: "Andhra Pradesh",
    listingStatus: "Active",
    listingDate: "01/06/23",
    propertyType: "residential",
    rating: 4,
    authorName: "John Doe",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=2",
    price: 150000,
    address: "456 Elmwood Ave, City B, Sed do eiusmod tempor incididunt ut.",
    bed: 4,
    tub: 3,
    area: 2000,
    state: "Assam",
    listingStatus: "Sold",
    listingDate: "15/05/23",
    propertyType: "corporate",
    rating: 4.5,
    authorName: "Jane Smith",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=3",
    price: 200000,
    address: "789 Maple Lane, City C, Ut enim ad minim veniam, quis nostrud.",
    bed: 2,
    tub: 1,
    area: 1200,
    state: "Bihar",
    listingStatus: "Active",
    listingDate: "03/06/23",
    propertyType: "residential",
    rating: 4,
    authorName: "David Johnson",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=4",
    price: 250000,
    address: "321 Oak Street, City D, Duis aute irure dolor in reprehenderit.",
    bed: 3,
    tub: 2,
    area: 1800,
    state: "Chhattisgarh",
    listingStatus: "Active",
    listingDate: "19/05/23",
    propertyType: "corporate",
    rating: 4.5,
    authorName: "Michael Brown",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=5",
    price: 300000,
    address: "567 Pine Avenue, City E, Excepteur sint occaecat cupidatat non.",
    bed: 4,
    tub: 3,
    area: 2200,
    state: "Goa",
    listingStatus: "Sold",
    listingDate: "07/06/23",
    propertyType: "residential",
    rating: 5,
    authorName: "Sarah Davis",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=6",
    price: 350000,
    address: "890 Cedar Road, City F, Nisi ut aliquid ex ea commodi.",
    bed: 3,
    tub: 2,
    area: 1600,
    state: "Gujarat",
    listingStatus: "Active",
    listingDate: "09/05/23",
    propertyType: "corporate",
    rating: 4,
    authorName: "Christopher Wilson",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=7",
    price: 400000,
    address: "123 Willow Court, City G, Lorem ipsum dolor sit amet, consectetur.",
    bed: 4,
    tub: 3,
    area: 2400,
    state: "Haryana",
    listingStatus: "Sold",
    listingDate: "12/06/23",
    propertyType: "residential",
    rating: 3.5,
    authorName: "Emily Anderson",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=8",
    price: 450000,
    address: "456 Birch Lane, City H, Duis aute irure dolor in reprehenderit.",
    bed: 2,
    tub: 1,
    area: 1100,
    state: "Himachal Pradesh",
    listingStatus: "Active",
    listingDate: "05/05/23",
    propertyType: "corporate",
    rating: 4.5,
    authorName: "Daniel Thompson",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=9",
    price: 500000,
    address: "789 Spruce Avenue, City I, Excepteur sint occaecat cupidatat non.",
    bed: 3,
    tub: 2,
    area: 1700,
    state: "Jharkhand",
    listingStatus: "Active",
    listingDate: "10/06/23",
    propertyType: "residential",
    rating: 5,
    authorName: "Olivia Martinez",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=10",
    price: 550000,
    address: "321 Elm Street, City J, Nisi ut aliquid ex ea commodi.",
    bed: 4,
    tub: 3,
    area: 2000,
    state: "Karnataka",
    listingStatus: "Sold",
    listingDate: "18/05/23",
    propertyType: "corporate",
    rating: 4,
    authorName: "James Taylor",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=11",
    price: 600000,
    address: "567 Oak Lane, City K, Lorem ipsum dolor sit amet consectetur.",
    bed: 3,
    tub: 2,
    area: 1600,
    state: "Kerala",
    listingStatus: "Active",
    listingDate: "02/06/23",
    propertyType: "residential",
    rating: 4.5,
    authorName: "Sophia Clark",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=12",
    price: 650000,
    address: "890 Maple Avenue, City L, Sed do eiusmod tempor incididunt ut.",
    bed: 4,
    tub: 3,
    area: 2200,
    state: "Madhya Pradesh",
    listingStatus: "Sold",
    listingDate: "14/05/23",
    propertyType: "corporate",
    rating: 4,
    authorName: "David Thompson",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=13",
    price: 700000,
    address: "123 Walnut Street, City M, Ut enim ad minim veniam, quis nostrud.",
    bed: 3,
    tub: 2,
    area: 1500,
    state: "Maharashtra",
    listingStatus: "Active",
    listingDate: "06/06/23",
    propertyType: "residential",
    rating: 4,
    authorName: "Ava Hernandez",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=14",
    price: 750000,
    address: "456 Cedar Avenue, City N, Duis aute irure dolor in reprehenderit.",
    bed: 4,
    tub: 3,
    area: 2000,
    state: "Manipur",
    listingStatus: "Active",
    listingDate: "11/05/23",
    propertyType: "corporate",
    rating: 4,
    authorName: "Ethan Ramirez",
  },
  {
    img: "https://source.unsplash.com/featured/?house&sig=15",
    price: 800000,
    address: "789 Pine Lane, City O, Excepteur sint occaecat cupidatat non.",
    bed: 2,
    tub: 2,
    area: 1200,
    state: "Meghalaya",
    listingStatus: "Sold",
    listingDate: "16/06/23",
    propertyType: "residential",
    rating: 4.5,
    authorName: "Mia Foster",
  },
];

export default buildingData;
